import './PracticeFullScreen.scss'

import { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import parse from 'html-react-parser'

import { EVENT_ACTION_PAGEVIEW, saveUserEvent } from '../../api/UserEvents'
import Loading from '../../../../templates/Loading'
import WebShare from 'components/web-share'
import Bookmark from 'components/bookmark/Bookmark'

export const PracticeFullScreen = ({
  practiceId,
  cache,
  eventCategory,
  getDataFunction,
  practiceType
}) => {
  const [prompts, setPrompts] = useState([])
  const [activeIndex, setActiveIndex] = useState()
  const [previousIndex, setPreviousIndex] = useState()
  const [isLoading, setIsLoading] = useState(true)

  // Helper function to update current and previous index
  const updateIndex = next => {
    setActiveIndex(next)
    setPreviousIndex(activeIndex)

    // Save for later
    localStorage.setItem('activeQuestionIndex' + practiceId, next)
  }

  // Helper function to get the proper class, depending on the affirmation state
  const getClassName = index => {
    let name = 'practiceType-question'

    if (index === activeIndex) name += ' active'
    else if (index === previousIndex) name += ' previous'

    return name
  }

  const showNext = () => {
    let next = activeIndex + 1

    // Out of bounds, reset
    if (next >= prompts.length) next = 0

    updateIndex(next)
  }

  const showPrevious = () => {
    let previous = activeIndex - 1

    // Out of bounds, go to end
    if (previous < 0) previous = prompts.length - 1

    updateIndex(previous)
  }

  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0)

    // Fetch Data
    ;(async function getQuestionDataAsync() {
      // Check cache first, but get the parent practice, so that we can
      // grab the title for the header
      const result = await getDataFunction(practiceId)
      const reformattedArray = result.map(obj => obj.post_title) || []
      const active =
        Number(localStorage.getItem('activeQuestionIndex' + practiceId)) || 0

      setPrompts(reformattedArray)
      setIsLoading(false)
      setActiveIndex(active)

      // Log access
      saveUserEvent(eventCategory, EVENT_ACTION_PAGEVIEW, practiceId)
    })()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [practiceId, cache])

  return (
    <Loading isLoaded={isLoading}>
      <Container className='practiceType-fullscreen-container'>
        <Bookmark categoryObjectId={practiceId} category={practiceType} />
        <WebShare
          text={prompts[activeIndex]}
          size='fs-5'
          buttonClass='position-absolute'
          color='text-black'
        />
        <nav className='practiceType-question-navigation'>
          <Row>
            <Col>
              <span className='nav-item' onClick={() => showPrevious()}>
                <i className='bi bi-arrow-left' /> Back
              </span>
            </Col>
            <Col className='text-right'>
              <span className='nav-item' onClick={() => showNext()}>
                Next <i className='bi bi-arrow-right' />
              </span>
            </Col>
          </Row>
        </nav>
        {prompts.length > 1 && (
          <>
            {prompts.map((content, index) => (
              <div className={getClassName(index)} key={index}>
                {parse(content)}
              </div>
            ))}
          </>
        )}
      </Container>
    </Loading>
  )
}
